import { reactive, getCurrentInstance, ref, computed } from 'vue';
import { useInitActionCombo } from '../../../commons/combobox/initActionCombo.js';
import { useRemoteCombobox } from '@/setup/remoteCombobox.js';
import { usefilterActionCombo } from '@/commons/combobox/filterActionCombo.js';
import accountingObjectAPI from '@/apis/di/accountingObjectAPI.js';
import accountingObjectInfoAPI from '@/apis/di/accountingObjectInfoAPI.js';
import { useInforCommons } from '../../utility/commons/inforCommons.js';
import { showError, showConfirm } from '@/commons/globalMessage';
import sASaleInvoiceAPI from '@/apis/sa/sASaleInvoiceAPI.js';
import store from '@/stores/store';
import { ModuleDbOption } from '@/stores/moduleConst';
export const useCAReceiptSaleDetailData = () => {
  const { proxy } = getCurrentInstance();
  const { comboboxLoadData } = useRemoteCombobox();
  const { extendFilter } = usefilterActionCombo();
  /**
   * Ẩn hiện container trên
   */
  const toggleAbove = ref(true);
  const toggleAboveHandler = () => {
    toggleAbove.value = !toggleAbove.value;
  };

  const comboboxDataRemote = reactive({
    account: [],
    bank: [],
    account_object_bank: [],
    inventory_item_code: [],
    stock_code: [],
    debit_account: [],
    credit_account: [],
    tax_account: [],
    inventory_account: [],
    cogs_account: [],
    budget_source_name: [],
    budget_chapter_code: [],
    budget_sub_kind_item_code: [],
    budget_item_code: [],
    budget_sub_item_code: [],
    accounting_object_code: [],
    activity_name: [],
    statistic_code: [],
    invoice_form: [],
    currency: [],
    cboPayForm: [
      {
        pay_form_name: 'TM',
      },
      {
        pay_form_name: 'CK',
      },
      {
        pay_form_name: 'TM/CK',
      },
    ],
  });
  /**
   * Khai báo tab active hiển thị ban đầu khi mở popup
   */
  const selectedTab = ref(0);
  const currentLayout = ref('');
  const selectedGrid = ref(1);

  /**
   * Chọn tab được active
   * @param value: giá trị tab active
   */
  const selectedGridHandler = value => {
    selectedGrid.value = value;
  };
  const selectedTabHandler = value => {
    selectedTab.value = value;
  };

  /**
   * Sự kiện chọn khách hàng
   * HQMINH 02.08.2022
   */
  const selectedAccount = ({ newData }, me) => {
    if (newData) {
      proxy.model.accounting_object_name = newData.accounting_object_name;
      proxy.model.accounting_object_address = newData.address;
      proxy.model.accounting_object_contact_name = newData.contact_name;
      proxy.model.inv_accounting_object_id = newData.accounting_object_id;
      proxy.model.inv_accounting_object_code = newData.accounting_object_code;
      proxy.model.inv_accounting_object_name = newData.accounting_object_name;
      proxy.model.inv_accounting_object_address = newData.address;
      proxy.model.inv_accounting_object_contact_name = newData.contact_name;
      proxy.model.company_tax_code = newData.company_tax_code;
      proxy.model.account_object_bank_account = '';
      proxy.model.account_object_bank_name = '';
      proxy.model.inv_bank_account = '';
      proxy.model.inv_bank_name = '';

      // Cập nhật đối tượng dưới gridDetail giống dữ liệu master
      if (me.model.gridData && me.model.gridData.length > 0) {
        me.model.gridData
          .filter(
            t =>
              t.state == proxy.$ms.constant.ModelState.Insert ||
              t.state == proxy.$ms.constant.ModelState.Update ||
              t.state == proxy.$ms.constant.ModelState.None
          )
          .forEach(item => {
            item.accounting_object_id = newData.accounting_object_id;
            item.accounting_object_code = newData.accounting_object_code;
            item.accounting_object_name = newData.accounting_object_name;
            item.state =
              item.state == proxy.$ms.constant.ModelState.None
                ? proxy.$ms.constant.ModelState.Update
                : proxy.$ms.constant.ModelState.Insert;
          });
      }

      //#region HQMINH 02.08.2022: sự kiện change nhà cung cấp xong thì gọi load lại tài khoản của nhà cung cấp
      //Custom lại payload
      if (newData.is_employee) {
        proxy.model.account_object_bank_account = newData.bank_account;
        proxy.model.account_object_bank_name = newData.bank_name;
        proxy.model.inv_bank_account = newData.bank_account;
        proxy.model.inv_bank_name = newData.bank_name;
        proxy.comboboxDataRemote.bank = null;
        // proxy.model.accounting_object_contact_name =
        //   newData.accounting_object_name;
        // proxy.model.inv_accounting_object_contact_name =
        //   newData.accounting_object_name;
      } else {
        let payload = {};

        payload.skip = 0;
        payload.sort = 'sort_order';
        payload.take = 10;

        // payload.sort = 'bank_code';
        payload.column = 'bank_account, bank_code, bank_name';
        payload.columns = 'bank_account, bank_name';
        let extend = [
          {
            Field: 'accounting_object_id',
            Value: proxy.model.accounting_object_id,
          },
        ];

        payload.filter = extendFilter(payload.filter, extend);

        //HQMINH 02.08.2022: Đến đây mới Call API gọi lại dữ liệu combobox và bind thông tin tài khoản đầu tiên của khách hàng nếu có
        accountingObjectInfoAPI.getComboboxPaging(payload).then(result => {
          if (result && result.length) {
            const dataBinding = result[0];
            proxy.model.account_object_bank_account = dataBinding.bank_account;
            proxy.model.account_object_bank_name = dataBinding.bank_name;
            proxy.model.inv_bank_account = dataBinding.bank_account;
            proxy.model.inv_bank_name = dataBinding.bank_name;
            proxy.comboboxDataRemote.bank = result;
          } else {
            proxy.model.account_object_bank_account = '';
            proxy.model.account_object_bank_name = '';
            proxy.model.inv_bank_account = '';
            proxy.model.inv_bank_name = '';
            proxy.model.inv_accounting_object_contact_name = '';
            proxy.comboboxDataRemote.bank = null;
          }
        });
      }

      //#endregion
    } else {
      proxy.model.accounting_object_name = '';
      proxy.model.account_object_bank_account = '';
      proxy.model.account_object_bank_name = '';
    }
  };

  /**
   * Sự kiện chọn khách hàng tab hóa đơn
   * HQMINH 10.08.2022
   */
  const selectedInvAccount = ({ newData }) => {
    if (newData) {
      proxy.model.inv_accounting_object_id = newData.accounting_object_id;
      proxy.model.inv_accounting_object_code = newData.accounting_object_code;
      proxy.model.inv_accounting_object_name = newData.accounting_object_name;
      proxy.model.inv_accounting_object_address = newData.address;
      proxy.model.company_tax_code = newData.company_tax_code;
      proxy.model.inv_accounting_object_contact_name = newData.contact_name;
      proxy.model.inv_bank_account = '';
      proxy.model.inv_bank_name = '';

      if (newData.is_employee) {
        proxy.model.inv_bank_account = newData.bank_account;
        proxy.model.inv_bank_name = newData.bank_name;
        proxy.model.accounting_object_contact_name = newData.accounting_object_name;
        proxy.model.inv_accounting_object_contact_name = newData.accounting_object_name;
        proxy.comboboxDataRemote.bankInv = null;
      } else {
        let payload = {};

        payload.skip = 0;
        payload.take = 10;

        payload.sort = 'sort_order';
        payload.column = 'bank_account, bank_code, bank_name';
        payload.columns = 'bank_account, bank_name';
        let extend = [
          {
            Field: 'accounting_object_id',
            Value: proxy.model.inv_accounting_object_id,
          },
        ];

        payload.filter = extendFilter(payload.filter, extend);

        //HQMINH 02.08.2022: Đến đây mới Call API gọi lại dữ liệu combobox và bind thông tin tài khoản đầu tiên của khách hàng nếu có
        accountingObjectInfoAPI.getComboboxPaging(payload).then(result => {
          if (result && result.length) {
            const dataBinding = result[0];
            proxy.model.inv_bank_account = dataBinding.bank_account;
            proxy.model.inv_bank_name = dataBinding.bank_name;
            proxy.comboboxDataRemote.bankInv = result;
          } else {
            proxy.model.inv_bank_account = '';
            proxy.model.inv_bank_name = '';
            proxy.comboboxDataRemote.bankInv = null;
          }
        });
      }
    } else {
      proxy.model.inv_accounting_object_id = '';
      proxy.model.inv_accounting_object_code = '';
      proxy.model.inv_accounting_object_name = '';
      proxy.model.inv_accounting_object_address = '';
      proxy.model.inv_bank_account = '';
      proxy.model.inv_bank_name = '';
      proxy.model.company_tax_code = '';
    }
  };

  const selectedBank = ({ newData }) => {
    if (newData) {
      proxy.model.account_object_bank_name = newData.bank_name;
    } else {
      proxy.model.account_object_bank_name = '';
    }
  };

  const selectedBankInv = ({ newData }) => {
    if (newData) {
      proxy.model.inv_bank_name = newData.bank_name;
    } else {
      proxy.model.inv_bank_name = '';
    }
  };

  const selectAccountObjectBank = ({ newData }) => {
    if (newData) {
      proxy.model.bank_name = newData.bank_name;
    } else {
      proxy.model.bank_name = '';
    }
  };

  /**
   * Biến dùng để disabled tiện ích
   * NNlinh 18.05.2022
   */
  const valueMode = computed(() => {
    return proxy.editMode != proxy.$ms.constant.FormState.View;
  });

  /**
   * Biến dùng để disabled tiện ích thêm mới chứng từ hiện thời
   * NNlinh 28.09.2022
   */
  const valueModeDuplicate = computed(() => {
    return proxy.editMode != proxy.$ms.constant.FormState.View;
  });
  /**
   * Biến dùng để disable nút Sao chép chứng từ (enable khi thêm/ sửa)
   * HQMINH 02.08.2022
   */
  const valueModeView = computed(() => {
    return proxy.editMode == proxy.$ms.constant.FormState.View;
  });

  /**
   * Biến dùng để disabled Xóa nếu chứng từ đã ghi sổ
   * HQMINH 02.08.2022
   */
  const disabledDelete = computed(() => {
    return proxy.editMode != proxy.$ms.constant.FormState.View || proxy.model.is_posted;
  });

  /**
   * Biến để disabled chỉ active khi click vào 1 dòng chi tiết
   * NTLOC 06.09.2022
   */
  const disableViewQuantity = computed(() => {
    let data = proxy.$refs['refDetail'].rowSelected;
    return data.selected != true;
  });

  /**
   * Biến disable lập hóa đơn
   * NNLINH 14.10.2022
   */
  const disabledGenerateInvoice = computed(() => {
    return (
      proxy.editMode != proxy.$ms.constant.FormState.View ||
      proxy.model.IsInvoiceGenerateData ||
      proxy.model.is_generate_invoice ||
      !proxy.$store.state.dbOption.dbOptions.Invoice ||
      proxy.model.IsElectronicTicket
    );
  });
  
  /**
   * Biến disable lấy vé điện tử
   * NNLINH 12.09.2023
   */
  const disabledGetTicket = computed(() => {
    return (
      proxy.editMode == proxy.$ms.constant.FormState.View ||
      proxy.model.is_invoice_exported ||
      proxy.model.is_generate_invoice 
    );
  });

  /**
   *Khai báo items của các button
   */
  const buttonUtilities = reactive([
    // {
    //   text: 'Thêm chứng từ',
    //   command: proxy.$ms.constant.Command.Add,
    //   disabledItem: valueMode
    // },
    {
      text: 'Thêm chứng từ',
      command: 'Add',
      disabledItem: valueMode,
      IsSubMenu: true,
      icon: 'right-arrow-grey',
      position: {
        at: 'right+15 top',
        my: 'left top',
      },
      subItem: [
        {
          text: 'Thu tiền mặt',
          command: 'ShowCAReceiptSale',
        },
        {
          text: 'Thu tiền gửi',
          command: 'ShowBADepositSale',
        },
      ],
    },
    {
      text: 'Thêm chứng từ hiện thời',
      command: proxy.$ms.constant.Command.Duplicate,
      disabledItem: valueModeDuplicate,
    },
    // {
    //   text: 'Xóa chứng từ hiện thời',
    //   command: proxy.$ms.constant.Command.Delete,
    //   disabledItem: disabledDelete,
    // },
    {
      text: 'Xem số lượng tồn vật tư',
      command: proxy.$ms.constant.Command.ViewQuantity,
      disabledItem: disableViewQuantity,
    },
    {
      text: 'Lập hóa đơn',
      command: proxy.$ms.constant.Command.GenerateInvoice,
      disabledItem: disabledGenerateInvoice,
    },
    {
      text: 'Lấy vé điện tử',
      command: proxy.$ms.constant.Command.GetElectronicTicket,
      disabledItem:disabledGetTicket,
    },
    {
      text: 'Xem số dư tài khoản',
      command: proxy.$ms.constant.Command.ViewAccount,
    },

    {
      text: 'Sao chép chứng từ',
      command: proxy.$ms.constant.Command.Copy,
      disabledItem: valueModeView,
    },
  ]);

  const buttonPrints = reactive([{ text: 'Chứng từ kế toán' }, { text: 'Tùy chọn in' }]);

  /**
   * Khởi tạo config cho combobox trong grid
   */
  const {
    inventoryItemComboConfig, //mã hàng hóa
    stockComboConfig, // kho
    accountComboConfig, //TK Nợ
    budgetSourceComboConfig, //Nguồn
    budgetChapterComboConfig, // Chương
    budgetSubKindItemComboConfig, //Khoản
    budgetItemComboConfig, //Mục
    budgetSubItemComboConfig, //Tiểu mục
    accountingObjectComboConfig, //Cán bộ
    activityComboConfig, // hoạt động
    statisticComboConfig, //thống kê

    //Load combobox
    onBankAccountComboboxLoadData,
    onInvoiceFormNumberComboboxLoadData,
    budgetDetailItemComboConfig, // Tiết tiểu mục
    projectComboConfig, //ctmt dự án
    invoiceFormNumberComboConfig, //mẫu số hóa đơn

    //Load comboboxz
    contractComboConfig,
    TaskComboConfig,
    topicComboConfig,
    fundStructureComboConfig,
    budgetKindItemComboConfig,
    accountComboMostDetailConfig,
    typeOfFundComboConfig,
    budgetProvideComboConfig,
    projectExpenseComboConfig
  } = useInitActionCombo(comboboxDataRemote, comboboxLoadData);

  //#region Khách hàng NCC
  const useAccountingObjectComboGrid = (comboboxDataRemote, comboboxLoadData) => {
    // func call api lấy dữ liệu combo
    const onAccountingObjectComboboxLoadData = (payload, row, column) => {
      payload.sort = 'is_employee, accounting_object_code, accounting_object_name';
      payload.columns += ',address,contact_name,bank_account,bank_name,company_tax_code,is_employee';
      let ors = [{ Field: 'inactive', Operator: 'NULL' }];
      let extend = [{ Field: 'inactive', Value: false, Ors: ors }];
      payload.filter = extendFilter(payload.filter, extend);
      comboboxLoadData(payload, accountingObjectAPI, comboboxDataRemote, column.dataField);
    };

    const onBankInfoComboboxLoadData = (payload, row, column) => {
      payload.sort = 'bank_code';
      payload.column += ',bank_name';
      let extend = [
        {
          Field: 'accounting_object_id',
          Value: proxy.model.accounting_object_id,
        },
      ];
      payload.filter = extendFilter(payload.filter, extend);
      comboboxLoadData(payload, accountingObjectInfoAPI, comboboxDataRemote, column.dataField);
    };

    return {
      onAccountingObjectComboboxLoadData, // trả về thêm để dùng chung cho cả combo không thuộc grid
      onBankInfoComboboxLoadData,
    };
  };

  const { onAccountingObjectComboboxLoadData, onBankInfoComboboxLoadData } = useAccountingObjectComboGrid(
    comboboxDataRemote,
    comboboxLoadData
  );

  //#endregion

  /**
   * Hàm format tiền
   * NNLINH 08.06.2022
   */
  function formatPrice(value) {
    if (value) {
      let val = (value / 1).toFixed(0).replace('.', ',');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    } else return 0;
  }

  /**
   * Xem số dư tài khoản
   * HQMINH 10.09.2022
   */
  const { viewAccount, viewQuantity } = useInforCommons();

  /**
   * Cập nhật dòng đang selected sau khi chọn xong phiếu nhập ở phương pháp tính giá đích danh
   * @param {*} rowSelected
   * @param {*} data
   * HQMINH 22.08.2022
   */
  const updateRowSelectedCustom = (rowSelected, data) => {
    if (rowSelected && Object.keys(rowSelected).length > 0 && data && Object.keys(data).length > 0) {
      //Đơn giá vốn
      rowSelected.outward_price = data.unit_price_balance;
      rowSelected.outward_amount = (data.unit_price_balance ?? 0) * (rowSelected.quantity ?? 0) || 0;
      // Kho
      rowSelected.stock_code = data.stock_code;
      rowSelected.stock_id = data.stock_id;
      //Đơn giá
      // rowSelected.unit_price = data.unit_price_balance;
      //Đơn giá quy đổi
      // rowSelected.unit_price_convert =
      //   (rowSelected.unit_price ?? 0) / (rowSelected.convert_rate ?? 1);
      // Thành tiền
      // rowSelected.amount =
      //   (rowSelected.quantity ?? 0) * (rowSelected.unit_price ?? 0) || 0;
      //Số CT đối trừ
      rowSelected.confronting_ref_id = data.ref_detail_id;
      rowSelected.confronting_ref_no = data.ref_no;
      //Ngày hết hạn
      rowSelected.expiry_date = data.expiry_date;
      //Số lô
      rowSelected.lot_no = data.lot_no;
    }
  };

  /**
   * @override
   * Hàm xóa chứng từ
   * NNLINH 21.09.2022
   */
  async function deleteVoucher(record) {
    //Kiểm tra phân quyền
    proxy.checkActionPermissionAlert(proxy.$ms.constant.Permission.Delete);
    let payload = {
      id: proxy.model.ref_id,
      type: 2,
    };
    let data = await sASaleInvoiceAPI.checkDataReference(payload);
    if (data && data.is_receipt) {
      //case liên quan biên lai
      deleteReceipt(data, record);
    }else if(data?.is_ticket){
      deleteTicket(data,record);
    } else {
      deleteInvoice(data, record);
    }
  }

  /**
   * Hàm xóa khi case chứng từ lập từ biên lai
   * NNLINH 07.04.2023
   */
  function deleteReceipt(data, record) {
    let message;
    if (data && data.ListInvoiceReference) {
      let refNo = '';
      //Lấy danh sách mã hóa đơn liên quan
      if (data && data.ListInvoiceReference && data.ListInvoiceReference.length) {
        refNo = data.ListInvoiceReference.map(x => {
          return (
            (x.inv_form_number == null ? '' : ' {0} - '.format(x.inv_form_number)) +
            (x.inv_series == null ? '' : '{0} - '.format(x.inv_series)) +
            (x.inv_no == null ? '' : '{0}'.format(x.inv_no))
          );
        }).join('; ');
      }
      message =
        'Chứng từ <span class="color-blue">{0}</span> đã lập biên lai. Nếu xóa chứng từ này thì biên lai coi như chưa hạch toán. Bạn có muốn xóa không?'.format(
          record.ref_no
        );
      let refTypeEnum = proxy.$ms.format.formatData(proxy.model.ref_type, {
        formatType: 100,
        enumName: 'RefType',
      });
      let title = 'Xóa ' + refTypeEnum.toLowerCase();
      showConfirm(message, title).then(async answer => {
        if (answer) {
          let temp = {};
          for (let i in record) {
            switch (i) {
              case 'parentNode':
              case 'isHide':
              case 'isSelected':
              case 'level':
              case '__vKeyValue':
              case '_isSelectedMultiple':
              case 'expanded':
                //bỏ qua 1 só trường
                break;
              default:
                temp[i] = record[i];
                break;
            }
          }
          let param = {
            Models: [temp],
            Ignores: [proxy.$ms.constant.PostedErrorCode.Delete_ErrorReferenceReceipt],
          };
          try {
            let result = await proxy.$store.dispatch(`${proxy.module}/delete`, param);
            proxy.deleteSuccess(record, result);
          } catch (ex) {
            proxy.deleteError(record, ex);
          }
        }
      });
    } else {
      proxy.delete(record);
    }
  }

  /**
   * Hàm xóa khi case chứng từ lập từ vé điện tử
   * NNLINH 07.04.2023
   */
   function deleteTicket(data, record) {
    let message;
    if (data && data.ListInvoiceReference) {
      let refNo = '';
      //Lấy danh sách mã hóa đơn liên quan
      if (data && data.ListInvoiceReference && data.ListInvoiceReference.length) {
        refNo = data.ListInvoiceReference.map(x => {
          return (
            (x.inv_form_number == null ? '' : ' {0} - '.format(x.inv_form_number)) +
            (x.inv_series == null ? '' : '{0} - '.format(x.inv_series)) +
            (x.inv_no == null ? '' : '{0}'.format(x.inv_no))
          );
        }).join('; ');
      }
      message =
        'Chứng từ <span class="color-blue">{0}</span> đã lập vé điện tử. Nếu xóa chứng từ này thì vé điện tử coi như chưa hạch toán. Bạn có muốn xóa không?'.format(
          record.ref_no
        );
      let refTypeEnum = proxy.$ms.format.formatData(proxy.model.ref_type, {
        formatType: 100,
        enumName: 'RefType',
      });
      let title = 'Xóa ' + refTypeEnum.toLowerCase();
      showConfirm(message, title).then(async answer => {
        if (answer) {
          let temp = {};
          for (let i in record) {
            switch (i) {
              case 'parentNode':
              case 'isHide':
              case 'isSelected':
              case 'level':
              case '__vKeyValue':
              case '_isSelectedMultiple':
              case 'expanded':
                //bỏ qua 1 só trường
                break;
              default:
                temp[i] = record[i];
                break;
            }
          }
          let param = {
            Models: [temp],
            Ignores: [proxy.$ms.constant.PostedErrorCode.Delete_ErrorReferenceTicket],
          };
          try {
            let result = await proxy.$store.dispatch(`${proxy.module}/delete`, param);
            proxy.deleteSuccess(record, result);
          } catch (ex) {
            proxy.deleteError(record, ex);
          }
        }
      });
    } else {
      proxy.delete(record);
    }
  }
  /**
   * Tách hàm xóa hóa đơn
   * @param {*} data
   * NNLINH 07.04.2023
   */
  function deleteInvoice(data, record) {
    let message;
    //Trường hợp hóa đơn đã phát hành,đã gửi cqt, chờ cqt, cqt từ chối,chưa gửi cqt
    if (data && data.publish_status) {
      if (
        data.publish_status == proxy.$ms.constant.SaleInvoiceStateReleaseType.Released ||
        data.publish_status == proxy.$ms.constant.SaleInvoiceStateCQT.NoSendTax ||
        data.publish_status == proxy.$ms.constant.SaleInvoiceStateCQT.SendTax ||
        data.publish_status == proxy.$ms.constant.SaleInvoiceStateCQT.Rejected ||
        data.publish_status == proxy.$ms.constant.SaleInvoiceStateCQT.SaleInvoiceInValid
      ) {
        let inv_no = '';
        if (data && data.ListInvoiceReference && data.ListInvoiceReference.length) {
          inv_no = data.ListInvoiceReference.map(x => {
            return (
              (x.inv_form_number == null ? '' : ' {0} - '.format(x.inv_form_number)) +
              (x.inv_series == null ? '' : '{0} - '.format(x.inv_series)) +
              (x.inv_no == null ? '' : '{0}'.format(x.inv_no))
            );
          }).join('; ');
        } else {
          inv_no =
            (data.GenerateInvoiceFormNumber == null ? '' : ' {0} - '.format(data.GenerateInvoiceFormNumber)) +
            (data.GenerateInvoiceSerie == null ? '' : '{0} - '.format(data.GenerateInvoiceSerie)) +
            (data.GenerateInvoiceRefNo == null ? '' : '{0}'.format(data.GenerateInvoiceRefNo));
        }
        message =
          'Chứng từ bán hàng đã lập hóa đơn<span class="color-blue">{0}</span>. Nếu bạn xóa chứng từ này thì hóa đơn coi như chưa hạch toán. Bạn có muốn xóa không?'.format(
            inv_no
          );
        let refTypeEnum = proxy.$ms.format.formatData(proxy.model.ref_type, {
          formatType: 100,
          enumName: 'RefType',
        });
        let title = 'Xóa ' + refTypeEnum.toLowerCase();
        showConfirm(message, title).then(async answer => {
          if (answer) {
            let temp = {};
            for (let i in record) {
              switch (i) {
                case 'parentNode':
                case 'isHide':
                case 'isSelected':
                case 'level':
                case '__vKeyValue':
                case '_isSelectedMultiple':
                case 'expanded':
                  //bỏ qua 1 só trường
                  break;
                default:
                  temp[i] = record[i];
                  break;
              }
            }
            let param = {
              Models: [temp],
              Ignores: ['Delete_ErrorReferenceInvoice'],
            };
            try {
              let result = await proxy.$store.dispatch(`${proxy.module}/delete`, param);
              proxy.deleteSuccess(record, result);
            } catch (ex) {
              proxy.deleteError(record, ex);
            }
          }
        });
      }
    }
    //nếu có mã hóa đơn thì thông báo cảnh báo
    else if (data && data.ListInvoiceReference) {
      let refNo = '';
      //Lấy danh sách mã hóa đơn liên quan
      if (data && data.ListInvoiceReference && data.ListInvoiceReference.length) {
        refNo = data.ListInvoiceReference.map(x => {
          return (
            (x.inv_form_number == null ? '' : ' {0} - '.format(x.inv_form_number)) +
            (x.inv_series == null ? '' : '{0} - '.format(x.inv_series)) +
            (x.inv_no == null ? '' : '{0}'.format(x.inv_no))
          );
        }).join('; ');
      }
      message =
        'Chứng từ bán hàng đã lập hóa đơn<span class="color-blue">{0}</span>. Nếu bạn xóa chứng từ này thì hóa đơn coi như chưa hạch toán. Bạn có muốn xóa không?'.format(
          refNo
        );
      let refTypeEnum = proxy.$ms.format.formatData(proxy.model.ref_type, {
        formatType: 100,
        enumName: 'RefType',
      });
      let title = 'Xóa ' + refTypeEnum.toLowerCase();
      showConfirm(message, title).then(async answer => {
        if (answer) {
          let temp = {};
          for (let i in record) {
            switch (i) {
              case 'parentNode':
              case 'isHide':
              case 'isSelected':
              case 'level':
              case '__vKeyValue':
              case '_isSelectedMultiple':
              case 'expanded':
                //bỏ qua 1 só trường
                break;
              default:
                temp[i] = record[i];
                break;
            }
          }
          let param = {
            Models: [temp],
            Ignores: [proxy.$ms.constant.PostedErrorCode.Delete_ErrorReferenceInvoice],
          };
          try {
            let result = await proxy.$store.dispatch(`${proxy.module}/delete`, param);
            proxy.deleteSuccess(record, result);
          } catch (ex) {
            proxy.deleteError(record, ex);
          }
        }
      });
    } else {
      proxy.delete(record);
    }
  }
  /**
   * (custom) copy cột xuống các dòng dưới
   * @param {*} objAssign : Dữ liệu để merge vào dòng đó
   * @param {*} metaData : Dữ liệu dòng hoặc dữ liệu vừa chọn combo
   * @param {*} column : Cột đang copy
   * @param {*} $grid : Grid
   * @param {*} lastIndex: các dòng được copy rowIndex => lastIndex
   * @param {*} rowIndex: Dòng đang active
   * @param {*} isShowCombo: MetaData lấy từ dòng dữ liệu hay lấy từ xổ combo
   * DMNGOC (08.11.2022)
   * ncdinh 26/05/2023 Xử lý phần tiền thuế ngầm định khi ẩn tab thuế , PBI 335388
   */
  function copyDownRowExtend(objAssign, metaData, column, $grid, lastIndex, rowIndex, isShowCombo) {
    let dbOptions = store.state[ModuleDbOption]?.dbOptions;
    switch (column.dataField) {
      case 'quantity':
        for (let i = rowIndex; i < lastIndex + 1; i++) {
          let item = $grid.dataView[i],
            quantity = objAssign.quantity || 0,
            unitPrice = item.unit_price || 0;
          item.quantity = quantity;
          item.outward_amount = Math.round((item.outward_price || 0) * quantity);
          item.quantity_convert = quantity * (item.convert_rate && item.convert_rate != 0 ? item.convert_rate : 1);
          item.tax_amount = dbOptions.UseTA
            ? item.tax_rate == proxy.$ms.constant.TaxRateInventory.NoSelected
              ? 0
              : Math.round(
                (quantity * unitPrice - quantity * unitPrice * ((item.discount_rate ?? 0) / 100)) *
                (item.tax_rate / 100)
              )
            : 0; // Tính lại tiền thuế
          item.amount = Math.round(quantity * unitPrice);
          item.discount_amount = quantity * unitPrice * ((item.discount_rate ?? 0) / 100);
        }

        let totalByQuantity = $grid.dataView.reduce((pre, cur) => {
          cur['amount'] = cur['amount'] ?? 0;
          pre = pre ?? 0;
          return pre + cur['amount'];
        }, 0);
        proxy.model.total_amount = totalByQuantity;
        break;
      case 'discount_rate': //tỷ lệ chiết khấu
        for (let i = rowIndex; i < lastIndex + 1; i++) {
          let item = $grid.dataView[i];
          item.discount_rate = objAssign.discount_rate || 0;
          item.discount_amount = Math.round((item.amount || 0) * (item.discount_rate / 100));
          item.tax_amount = dbOptions.UseTA
            ? item.tax_rate == proxy.$ms.constant.TaxRateInventory.NoSelected
              ? 0
              : Math.round(
                (item.amount - (item.discount_rate > 0 ? item.amount * (item.discount_rate / 100 ?? 0) : 0)) *
                (item.tax_rate / 100)
              )
            : 0;
        }
        break;
      case 'unit_price':
        for (let i = rowIndex; i < lastIndex + 1; i++) {
          let item = $grid.dataView[i],
            quantity = item.quantity || 0,
            unitPrice = objAssign.unit_price || 0;
          item.unit_price = unitPrice;
          item.unit_price_convert = unitPrice / (item.convert_rate ?? 1); // Đơn giá quy đổi
          item.amount = Math.round(quantity * unitPrice); // thành tiền
          item.discount_amount = Math.round(quantity * unitPrice * ((item.discount_rate ?? 0) / 100));
          item.tax_amount = dbOptions.UseTA
            ? item.tax_rate == proxy.$ms.constant.TaxRateInventory.NoSelected
              ? 0
              : Math.round(
                (quantity * unitPrice - quantity * unitPrice * ((item.discount_rate ?? 0) / 100)) *
                ((item.tax_rate ?? 0) / 100)
              )
            : 0;
        }
        break;
      case 'amount':
        for (let i = rowIndex; i < lastIndex + 1; i++) {
          let item = $grid.dataView[i];
          item.amount = objAssign.amount || 0;
          let quantity = item.quantity || 0;
          item.unit_price = quantity > 0 ? item.amount / quantity : item.unit_price; // đơn giá
          item.unit_price_convert = item.amount / (quantity == 0 ? 1 : quantity) / (item.convert_rate ?? 1); // đơn giá quy đổi
          item.discount_amount =
            item.discount_rate && item.discount_rate > 0 ? Math.round(item.amount * (item.discount_rate / 100)) : 0; // giảm giá
          item.tax_amount = dbOptions.UseTA
            ? item.tax_rate == proxy.$ms.constant.TaxRateInventory.NoSelected
              ? 0
              : Math.round(
                (item.amount -
                  (item.discount_rate && item.discount_rate > 0
                    ? item.amount * (item.discount_rate / 100 ?? 0)
                    : 0)) *
                (item.tax_rate / 100)
              )
            : 0;
        }

        break;
      case 'tax_rate':
        for (let i = rowIndex; i < lastIndex + 1; i++) {
          let item = $grid.dataView[i];
          item.tax_rate = objAssign.tax_rate;
          if (item.amount > 0) {
            item.tax_amount =
              item.tax_rate == proxy.$ms.constant.TaxRateInventory.NoSelected
                ? 0
                : Math.round(((item.amount ?? 0) - (item.discount_amount ?? 0)) * (item.tax_rate / 100));
          } else {
            item.tax_amount = 0;
          }
        }
        break;
      case 'tax_amount': //Tính tổng tiền thuế
        const totalTaxAmount = $grid.dataView.reduce((pre, cur) => {
          cur['tax_amount'] = cur['tax_amount'] ?? 0;
          pre = pre ?? 0;
          return pre + cur['tax_amount'];
        }, 0);
        proxy.model.total_tax_amount = totalTaxAmount ?? 0;
        break;
      case 'outward_price':
        for (let i = rowIndex; i < lastIndex + 1; i++) {
          let item = $grid.dataView[i];
          item.outward_amount = Math.round((objAssign.outward_price || 0) * (item.quantity || 0));
        }
        break;
      case 'inward_price':
        for (let i = rowIndex; i < lastIndex + 1; i++) {
          let item = $grid.dataView[i];
          item.inward_amount = Math.round((objAssign.inward_price || 0) * (item.quantity || 0));
        }
        break;
      case 'inventory_item_code': // mã hàng
        let convertRate = 1;
        if (metaData?.convert_rate) {
          convertRate = metaData.convert_rate;
        }
        for (let i = rowIndex; i < lastIndex + 1; i++) {
          let item = $grid.dataView[i];

          if (item.generate_by_invoice == true) {
            item.is_service = metaData.is_service; // Mã hàng là dịch vụ hay không
            item.stock_code =
              i != rowIndex
                ? metaData.is_service
                  ? null
                  : metaData.default_stock_code && metaData.default_stock_code != ''
                    ? metaData.default_stock_code
                    : item.stock_code
                : item.stock_code; // mã kho
            item.default_stock_code =
              metaData.default_stock_code && metaData.default_stock_code != '' ? metaData.default_stock_code : null; // mã kho ngầm định
            item.default_stock_id =
              metaData.default_stock_id && metaData.default_stock_id != '' ? metaData.default_stock_id : null; // id kho ngầm định
            item.stock_id =
              i != rowIndex
                ? metaData.is_service
                  ? null
                  : metaData.default_stock_id && metaData.default_stock_id != ''
                    ? metaData.default_stock_id
                    : item.stock_id
                : item.stock_id; // id kho
            item.inventory_account = !metaData.inventory_account ? item.inventory_account : metaData.inventory_account; // tk kho ngầm định
            //Không có thì mặc định lấy 632 theo bug kiến nghị : 173294
            item.cogs_account = !metaData.cogs_account ? item.cogs_account : metaData.cogs_account; // TK giá vốn
            item.quantity_convert = (metaData.quantity || 0) * convertRate; // Số lượng quy đổi
            item.unit_price = metaData.unit_price || 0;
            item.unit_price_convert =
              (metaData.unit_price && metaData.unit_price != 0 ? metaData.unit_price : 0) * convertRate; //Đơn giá quy đổi
            item.classes = metaData.classes;
          } else {
            item.description = metaData.inventory_item_name || metaData.description; // diễn giải
            item.is_service = metaData.is_service; // Mã hàng là dịch vụ hay không
            item.stock_code =
              i != rowIndex
                ? metaData.is_service
                  ? null
                  : metaData.default_stock_code && metaData.default_stock_code != ''
                    ? metaData.default_stock_code
                    : item.stock_code
                : item.stock_code; // mã kho
            item.default_stock_code =
              metaData.default_stock_code && metaData.default_stock_code != '' ? metaData.default_stock_code : null; // mã kho ngầm định
            item.default_stock_id =
              metaData.default_stock_id && metaData.default_stock_id != '' ? metaData.default_stock_id : null; // id kho ngầm định
            item.stock_id =
              i != rowIndex
                ? metaData.is_service
                  ? null
                  : metaData.default_stock_id && metaData.default_stock_id != ''
                    ? metaData.default_stock_id
                    : item.stock_id
                : item.stock_id; // id kho
            item.unit = metaData.unit; // Đơn vị tính
            item.unit_price = metaData.unit_price && metaData.unit_price != 0 ? metaData.unit_price : 0; // Đơn giá
            item.tax_rate = metaData.tax_rate ?? proxy.$ms.constant.TaxRateInventory.NoSelected; // thuế suất
            item.inventory_account = !metaData.inventory_account ? item.inventory_account : metaData.inventory_account; // tk kho ngầm định
            //Không có thì mặc định lấy 632 theo bug kiến nghị : 173294
            item.cogs_account = !metaData.cogs_account ? item.cogs_account : metaData.cogs_account; // TK giá vốn
            item.quantity_convert = (metaData.quantity || 0) * convertRate; // Số lượng quy đổi
            item.unit_price_convert = (item.unit_price ?? 0) * convertRate; //Đơn giá quy đổi
            item.amount = Math.round((metaData.quantity || 0) * (item.unit_price ?? 0)); // Thành tiền
            item.tax_amount = dbOptions.UseTA
              ? (metaData.tax_rate ?? proxy.$ms.constant.TaxRateInventory.NoSelected) ==
                proxy.$ms.constant.TaxRateInventory.NoSelected
                ? 0
                : Math.round(
                  ((metaData.quantity ?? 0) * (item.unit_price ?? 0) -
                    (item.discount_amount ? item.discount_amount ?? 0 : 0)) *
                  ((metaData.tax_rate ?? 0) / 100)
                )
              : 0; // Tính lại tiền thuế
            item.discount_amount =
              item.discount_rate > 0
                ? Math.round(metaData.quantity * (item.unit_price ?? 0) * (item.discount_rate / 100 ?? 0))
                : 0; // giảm giá
            item.classes = metaData.classes;
            item.tax_amount = dbOptions.UseTA
              ? ((item.amount || 0) * (!(metaData.tax_rate > 0) ? 0 : metaData.tax_rate)) / 100
              : 0;
          }
          
          // HMDUC2 13/06/2024: Gán thêm inventory_item_id của mã hàng khi coppy dòng
          // cho cả TH lập từ hóa đơn
          if(!item.hasOwnProperty('inventory_item_id') || item.inventory_item_id == null){
            item.inventory_item_id = metaData.inventory_item_id;
          }

          item.unit_price_convert = Math.round((item.unit_price || 0) / (metaData.convert_rate || 1));
          if (
            proxy.defaultData &&
            proxy.defaultData?.default_credit_account_category_id &&
            proxy.dbOptions.AllowRestrictAccountNumber &&
            metaData.sale_account
          ) {
            // Check thông tin TK có để bind dữ liệu mặc định
            let lsDataCredit = proxy.defaultData?.default_credit_account_category_id.split(';');
            if (lsDataCredit.length > 0 && lsDataCredit.some(x => metaData.sale_account.startsWith(x))) {
              item.credit_account = metaData.sale_account;
            }
          }

          // Nếu VTHH có mã kho thì cập nhật lại
          if (metaData.is_service != true && metaData.default_stock_code) {
              item.stock_code= metaData.default_stock_code; // mã kho
              item.stock_id = metaData.default_stock_id;
          }

          item.classes = {};
          // Nếu mã hàng chọn là dịch vụ => disable kho
          if (metaData.is_service) {
            item.classes.stock_code = 'noClick';
            item.stock_code = null;
            item.stock_id = null;
          }
          item.is_service = metaData.is_service;

          // Cache lại Tên hàng ở model (sử dụng để build câu cảnh báo vượt quá số lượng tồn khi cất)
          item.inventory_item_name = metaData.inventory_item_name;
          // Cache lại Tên từ kho ở model (sử dụng để build câu cảnh báo vượt quá số lượng tồn khi cất)
          item.stock_name = metaData.default_stock_name;
          // Cache lại Là dịch vụ ở model (sử dụng để check xem nếu VTHH là dịch vụ thì sẽ không validate vượt quá số tồn khi xuất)
          item.is_service = metaData.is_service ?? false;
          // Cache lại Tỷ lệ quy đổi ở model (sử dụng để tính lại số lượng quy đổi, đơn giá quy đổi)
          item.convert_rate = metaData.convert_rate ?? null;

          // Cache lại Là dịch vụ ở model (sử dụng để check xem nếu VTHH là dịch vụ thì sẽ không validate vượt quá số tồn khi xuất)
          item.is_service = metaData.is_service ?? false;

          // Xóa số CT đối trừ của mã hàng trước đó để show form cho mã hàng mới
          delete item.confronting_ref_id;
          delete item.confronting_ref_no;
          // Xóa cờ check close popup của mã hàng trước đó để show form cho mã hàng mới
          delete item.is_closed_popup_real_name;
        }
        break;
      case 'stock_code':
        // Cache lại Tên từ kho ở model (sử dụng để build câu cảnh báo vượt quá số lượng tồn khi cất)
        for (let i = rowIndex; i < lastIndex + 1; i++) {
          let item = $grid.dataView[i];
          if (objAssign.stock_code) {
            item.stock_name = metaData.stock_name;
            item.stock_id = metaData.stock_id;
          } else {
            item.stock_name = null;
            item.stock_id = null;
          }
        }

        break;
      case 'discount_amount': // CK, giảm giá
        for (let i = rowIndex; i < lastIndex + 1; i++) {
          let item = $grid.dataView[i];
          item.tax_amount = dbOptions.UseTA
            ? item.tax_rate == proxy.$ms.constant.TaxRateInventory.NoSelected
              ? 0
              : Math.round(((item.amount ?? 0) - (objAssign.discount_amount ?? 0)) * (item.tax_rate / 100))
            : 0;
        }
        break;
      default:
        break;
    }
  }

  return {
    toggleAbove,
    toggleAboveHandler,
    comboboxDataRemote,
    selectedAccount,
    selectedBank,
    selectedBankInv,
    selectedGrid,
    selectedGridHandler,
    selectedTab,
    currentLayout,
    selectedTabHandler,
    buttonUtilities,
    buttonPrints,
    inventoryItemComboConfig,
    stockComboConfig,
    accountComboConfig,
    budgetSourceComboConfig, //Nguồn
    budgetChapterComboConfig, // Chương
    budgetSubKindItemComboConfig, //Khoản
    budgetItemComboConfig, //Mục
    budgetSubItemComboConfig, //Tiểu mục
    accountingObjectComboConfig, //Cán bộ
    activityComboConfig, // hoạt động
    statisticComboConfig, //thống kê
    onAccountingObjectComboboxLoadData,
    onBankAccountComboboxLoadData,
    onInvoiceFormNumberComboboxLoadData,
    formatPrice,
    useAccountingObjectComboGrid,
    onBankInfoComboboxLoadData,
    selectAccountObjectBank,
    budgetDetailItemComboConfig, // Tiết tiểu mục
    projectComboConfig, //ctmt dự án
    invoiceFormNumberComboConfig, //mẫu số hóa đơn

    //Load combobox
    contractComboConfig,
    TaskComboConfig,
    topicComboConfig,
    fundStructureComboConfig,
    budgetKindItemComboConfig,
    typeOfFundComboConfig,
    budgetProvideComboConfig,

    selectedInvAccount,
    viewAccount,
    viewQuantity,
    updateRowSelectedCustom,
    accountComboMostDetailConfig,
    deleteVoucher,
    copyDownRowExtend,
    disableViewQuantity,
    projectExpenseComboConfig
  };
};
